import React, { useEffect } from 'react'
import { BrowserRouter } from 'react-router'
import { I18nextProvider } from 'react-i18next'
import Routes from './config/Routes'
import i18n from '../i18n'
import { ThemeProvider } from 'styled-components'
import { appTheme } from './config/styled'
import Session from '../javascripts/layouts/v2/Session'
import { session_path } from '../routes'
import TagManager from 'react-gtm-module'
import 'css/tailwind.css'

export const SessionContext = React.createContext<Session>(null)

const setCsrfMetaTags = (session: Session) => {
  if (!session.csrf_token) return

  const existingParam = document.querySelector('meta[name="csrf-param"]')
  const existingToken = document.querySelector('meta[name="csrf-token"]')
  if (existingParam) existingParam.remove()
  if (existingToken) existingToken.remove()

  const csrfParam = document.createElement('meta')
  csrfParam.name = 'csrf-param'
  csrfParam.content = session.csrf_param
  document.head.appendChild(csrfParam)

  const csrfToken = document.createElement('meta')
  csrfToken.name = 'csrf-token'
  csrfToken.content = session.csrf_token
  document.head.appendChild(csrfToken)
}

const updateDataLayer = (session: Session) => {
  const userId = session.user?.id

  if (!userId) { return }

  TagManager.dataLayer({ dataLayer: { uid: userId } })
}

const App: React.FC = () => {
  const [session, setSession] = React.useState<Session>(null)

  // NOTE: ワーカーの各コンポーネントでセッション情報を扱えるようにするため、セッションAPIを実行しています。
  // 詳細 → https://github.com/crowdtech/crowdtech/pull/27412#issuecomment-2154261434
  useEffect(() => {
    void fetch(session_path())
      .then(response => response.json())
      .then((json: Session) => {
        setCsrfMetaTags(json)
        setSession(json)
        updateDataLayer(json)
      })
  }, [])

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <SessionContext.Provider value={session}>
          <ThemeProvider theme={appTheme}>
            <Routes />
          </ThemeProvider>
        </SessionContext.Provider>
      </BrowserRouter>
    </I18nextProvider>
  )
}

export default App
